import DetalleHistoricidad from './DetalleHistoricidad';

export default function HistoricidadDetail() {
  return <DetalleHistoricidad />;
}






